/* eslint-disable camelcase */
import en_auth from './en/auth.json';
import en_common from './en/common.json';
import en_tools from './en/tools.json';
import es_auth from './es/auth.json';
import es_common from './es/common.json';
import es_tools from './es/tools.json';
import pt_auth from './pt/auth.json';
import pt_common from './pt/common.json';
import pt_contents_types from './pt/contents-types.json';
import pt_tools from './pt/tools.json';

export default {
  es: [es_auth, es_common, es_tools],
  en: [en_auth, en_common, en_tools],
  pt: [pt_auth, pt_common, pt_tools, pt_contents_types],
};

// Recursos específicos por tenant: { '<tenant.name>': { <lang>: [<recursos>] } }
export const tenantSpecificResources = {};
